import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    options: Object,
  };

  disconnect() {
    if (this.chart !== undefined) {
      this.chart.dispose();
      this.chart = null;
    }
  }

  ArticleVisitsChart = () => {
    this.chart = window.echarts.init(document.getElementById('article-visits-chart'));
    this.chart.setOption(this.optionsValue);
  };

  whenEchartsAvailable = () => {
    const interval = setInterval(() => {
      if (window.echarts !== undefined) {
        this.ArticleVisitsChart();
        window.onresize = () => {
          if (this.chart !== null) {
            this.chart.resize();
          }
        };
        clearInterval(interval);
      }
    }, 10);
  };

  initialize() {
    this.whenEchartsAvailable();
  }
}
